// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__1dNVb","Heading":"style_Heading__3wawL","Link":"style_Link__2JZO3"};